import apiClient from '../apiClient';
import { GET_DATA_TRANSFER_LOGS_URL } from '../apiUrl';

const getDataTransferLogsApi = () => {
  return apiClient.get(GET_DATA_TRANSFER_LOGS_URL);
};

export default getDataTransferLogsApi;
